import React, { useState, useEffect } from "react";
import { MapContainer, TileLayer, Marker, useMapEvents, useMap } from "react-leaflet";
import L from "leaflet";
import "leaflet/dist/leaflet.css";

// Fix marker icon issue
delete L.Icon.Default.prototype._getIconUrl;
L.Icon.Default.mergeOptions({
  iconUrl: "https://unpkg.com/leaflet@1.9.4/dist/images/marker-icon.png",
  iconRetinaUrl: "https://unpkg.com/leaflet@1.9.4/dist/images/marker-icon-2x.png",
  shadowUrl: "https://unpkg.com/leaflet@1.9.4/dist/images/marker-shadow.png",
});

// Resizes map properly
function ResizeHandler() {
  const map = useMap();
  useEffect(() => {
    map.invalidateSize();
  }, [map]);
  return null;
}

// Automatically pans map to new center
function PanToLocation({ position }) {
  const map = useMap();
  useEffect(() => {
    if (position) {
      map.setView(position, 13, { animate: true });
    }
  }, [position, map]);
  return null;
}

// Handles click on map and fetches address
function ClickableMarker({ position, setPosition, setGeoLocation }) {
  useMapEvents({
    click(e) {
      const { lat, lng } = e.latlng;
      setPosition(e.latlng);

      const geoStr = `${lat.toFixed(6)},${lng.toFixed(6)}`;
      setGeoLocation(geoStr);

      // Reverse geocode using Nominatim API
      fetch(`https://nominatim.openstreetmap.org/reverse?format=jsonv2&lat=${lat}&lon=${lng}`)
        .then((res) => res.json())
        .then((data) => {
          const addr = data.address || {};
          const fullAddress = data.display_name || "";
          const city = addr.city || addr.town || addr.village || addr.county || "";

        
        })
        .catch((err) => {
          console.error("Reverse geocoding error:", err);
        
        });
    },
  });

  return position ? <Marker position={position} /> : null;
}

// Main Component
export default function LeafletMapPicker({ setGeoLocation }) {
  const [position, setPosition] = useState(null);
  const [mapCenter, setMapCenter] = useState([20.5937, 78.9629]); // Default: India

  useEffect(() => {
    if ("geolocation" in navigator) {
      navigator.geolocation.getCurrentPosition(
        (pos) => {
          const { latitude, longitude } = pos.coords;
          const currentPos = [latitude, longitude];
          setPosition(currentPos);
          setMapCenter(currentPos);
          setGeoLocation(`${latitude.toFixed(6)},${longitude.toFixed(6)}`);

          // Fetch address for current position
        fetch(`https://nominatim.openstreetmap.org/reverse?format=jsonv2&lat=${latitude}&lon=${longitude}`)
  .then((res) => res.json())
  .then((data) => {
    const addr = data.address || {};
    const fullAddress = data.display_name || "";
    const city = addr.city || addr.town || addr.village || addr.county || "";

  
            })
            .catch((err) => {
              console.error("Reverse geocoding error:", err);

            });
        },
        () => {
          console.warn("Geolocation permission denied.");
          setPosition(null);
        }
      );
    }
  }, [setGeoLocation]);

  return (
    <MapContainer center={mapCenter} zoom={13} scrollWheelZoom={true} style={{ height: "400px", width: "100%" }}>
      <ResizeHandler />
      <PanToLocation position={mapCenter} />
      <TileLayer url="https://{s}.tile.openstreetmap.org/{z}/{x}/{y}.png" />
      <ClickableMarker
        position={position}
        setPosition={setPosition}
        setGeoLocation={setGeoLocation}
      />
    </MapContainer>
  );
} 